import { render, staticRenderFns } from "./ChangeInvoiceAddresseeDialog.vue?vue&type=template&id=a8b54344&"
import script from "./ChangeInvoiceAddresseeDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeInvoiceAddresseeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports